import { urls } from "../config";
import { AxiosInstancePrivate } from "../utils/AxiosInstance";
import { GTM_EVENTS } from "../utils/constants";

const privateAxios = AxiosInstancePrivate();

export const getSearchCriteria = async () => {
	const response = await privateAxios.get(urls.getCriteria);
	return response?.data;
};

export const getSearchResults = async (pagination,sortModel,searchData, pushToDL) => { 
	// when sorting using sales news no column, field name by default will be numberAndLink 
	// So it must be changed to field name matching with backend database
	if(sortModel[0]?.field === "numberAndLink") {
		sortModel = structuredClone(sortModel) // deep copy to prevent original arr modification
		sortModel[0].field = "bulletin_no"
	}

	const response = await privateAxios.post(urls.searchResult, {pagination,sortModel,...searchData});

	const searchCriteria = {
		bulletin_dt: searchData?.bulletinDt?.value?.trim() ?? null,
		description: searchData?.description?.trim() ?? null,
		models: searchData?.models?.map(({ value }) => value) ?? null,
		promo_end_dt: searchData?.promoEndDt?.value?.trim() ?? null,
		promo_start_dt: searchData?.promoStartDt?.value?.trim() ?? null,
		sales_news_nos: searchData?.salesNewsNos?.value?.trim() ?? null,
		sales_news_types: searchData?.salesNewsTypes?.value?.trim() ?? null,
	};
	pushToDL?.(GTM_EVENTS.SEARCH_SUBMIT,{
		button_text: 'search',
		search_criteria: searchCriteria,
	})
	return response?.data;
};

export const downloadAllSalesNewsResult = async (
	sortModel, searchData, download,
	emails, selectedIds, pushToDL
) => {
	try {
		// when sorting using sales news no column, field name by default will be numberAndLink 
		// So it must be changed to field name matching with backend database
		if(sortModel[0]?.field === "numberAndLink") {
			sortModel = structuredClone(sortModel) // deep copy to prevent original arr modification
			sortModel[0].field = "bulletin_no"
		}

		const response = await privateAxios.post(urls.downloadAllResult, {
			sortModel, ...searchData, download, emails, selectedIds
		});
		if(download){
			pushToDL?.(GTM_EVENTS.EMAIL_ME,{
				button_text: 'Email * Files (PDF)',
				bulletins: selectedIds,
			})
		}
		return response?.data;
	} catch (error) {
		console.error('Error in getting all SalesNews Result ->', error);
		throw error;
	}
};

export const getbulletinSignedURL = async ( bulletinNo, jwtToken ) =>{
	const response = await privateAxios.post(urls.bulletinSignedURL, {bulletinNo, jwtToken});
	return response?.data;
}

export const downloadBulletinPDF = async (salesnewsNumbers, pushToDL) => {
    const response = await privateAxios.post(urls.downloadBulletinPDF, {salesnewsNumbers}); 
	pushToDL?.(GTM_EVENTS.DOWNLOAD, {
		button_text: 'Download * Files (PDF)',
		bulletins: salesnewsNumbers,
	})
    return response?.data;
}
export const getSalesNewsMailLink = async (token) => {
    const response = await privateAxios.get(urls.viewBulletin, { params: { token: token } }); 
    return response?.data;
}
export const getSalesNewsMailLinkAuth = async (token) => {
    const response = await privateAxios.get(urls.viewAuth, { params: { token: token } }); 
    return response?.data;
}